import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// src/main.jsx ou src/index.jsx
import "./styles/index.css";
// src/index.jsx
import './i18n';
import { getInitialTheme, applyTheme } from './theme';
applyTheme(getInitialTheme());


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Retire le splash de démarrage une fois React monté (fondu doux).
function hideAppSplash() {
  const splash = document.getElementById('app-splash');
  if (!splash) return;
  splash.classList.add('fm-splash-hide');
  window.setTimeout(() => splash.remove(), 600);
}
if (typeof window !== 'undefined') {
  // Durée minimale d'affichage du splash (pour ne pas qu'il flashe trop vite).
  const MIN_SPLASH_MS = 1600;
  window.requestAnimationFrame(() =>
    window.requestAnimationFrame(() => {
      const elapsed = (window.performance && performance.now()) || 0;
      const wait = Math.max(250, MIN_SPLASH_MS - elapsed);
      window.setTimeout(hideAppSplash, wait);
    })
  );
}

reportWebVitals();
